import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initialState = {
    actionExpanded: true,
};

export default createReducer(initialState, {
    [actions.setActionExpanded]: (state, action) => {
        return { ...state, actionExpanded: action.payload };
    },
});
